import { RoutineColors } from "@/utilities/routineColors";
import type { Routine } from "instantdb/types";

export const MENTAL_ROUTINES: Partial<Routine>[] = [
  {
    id: "morning-mindfulness-practice",
    title: "Morning Mindfulness Practice",
    symbol: "🧘",
    description: "Begin your day with clarity and present-moment awareness",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[0].value,
    steps: [
      {
        id: "mental-mindfulness-1",
        title: "Breathing focus",
        description: "Take 10 deep breaths, fully focusing on each inhale and exhale",
      },
      {
        id: "mental-mindfulness-2",
        title: "Body scan",
        description: "Spend 2-3 minutes noticing sensations throughout your body",
      },
      {
        id: "mental-mindfulness-3",
        title: "Intention setting",
        description: "Choose one quality to embody throughout your day",
      },
    ],
  },
  {
    id: "digital-detox-hour",
    title: "Digital Detox Hour",
    symbol: "🧘",
    description: "Create space for mental clarity by disconnecting from technology",
    dailyRoutine: true,
    selectedDays: [],
    color: RoutineColors[1].value,
    steps: [
      {
        id: "mental-detox-1",
        title: "Power down",
        description: "Turn off all devices and notifications for one hour",
      },
      {
        id: "mental-detox-2",
        title: "Engage in analog activity",
        description: "Read a physical book, journal, or practice a hobby",
      },
      {
        id: "mental-detox-3",
        title: "Reflect on experience",
        description: "Notice how you feel during and after the technology break",
      },
    ],
  },
  {
    id: "weekly-mental-health-check-in",
    title: "Weekly Mental Health Check-in",
    symbol: "🧘",
    description: "Regularly assess and nurture your mental wellbeing",
    dailyRoutine: false,
    selectedDays: [{ day: "sunday", datetime: "19:00:00.000Z" }],
    color: RoutineColors[2].value,
    steps: [
      {
        id: "mental-checkin-1",
        title: "Emotional inventory",
        description: "Journal about your predominant emotions from the past week",
      },
      {
        id: "mental-checkin-2",
        title: "Stressor identification",
        description: "Note any recurring challenges and brainstorm potential solutions",
      },
      {
        id: "mental-checkin-3",
        title: "Self-care planning",
        description: "Schedule specific mental health activities for the coming week",
      },
    ],
  },
];
